import { supabase } from "../../../supabaseClient";

export async function fetchTournamentFinalizationFlags(tournamentId) {
  // Fetch tournament basic data
  const { data: tournamentData, error: tournamentError } = await supabase
    .from("tournaments")
    .select("payoutTableId,payoutRatioNumerator,payoutRatioDenominator")
    .eq("id", tournamentId)
    .single();

  if (tournamentError) throw tournamentError;

  // Fetch verification status from the new verification system
  const { data: verificationStates, error: verificationError } = await supabase
    .from("verificationStates")
    .select("entityType, isVerified")
    .eq("tournamentId", tournamentId)
    .in("entityType", ["payouts", "results", "tournament"]);

  if (verificationError) throw verificationError;

  // Map verification states to the expected format
  // Handle case where verificationStates might be empty
  const verificationStatesArray = verificationStates || [];

  const payoutVerification = verificationStatesArray.find(
    (vs) => vs.entityType === "payouts"
  );
  const resultsVerification = verificationStatesArray.find(
    (vs) => vs.entityType === "results"
  );
  const tournamentVerification = verificationStatesArray.find(
    (vs) => vs.entityType === "tournament"
  );

  const result = {
    ...tournamentData,
    isPayoutFinalized: payoutVerification?.isVerified || false,
    isResultsFinalized: resultsVerification?.isVerified || false,
    isTournamentFinalized: tournamentVerification?.isVerified || false,
  };

  return result;
}
